import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/Auth'

type Props = {
    children: JSX.Element
}

const AdminGuardedRoute = (props: Props) => {
    const location = useLocation()
    const { getUser } = useAuth()
    if (getUser()?.admin) {
        return props.children
    }
    if (getUser()?.tipster) {
        return <Navigate to={location.pathname.replace('admin', 'tipster')} />
    } else {
        return <Navigate to={location.pathname.replace('admin', 'app')} />
    }
}

export default AdminGuardedRoute
